var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tabs',{staticClass:"mb-3",attrs:{"items":_vm.sections,"active-item":_vm.section},on:{"item-change":function($event){_vm.section = $event}}}),_c('menus-edit',{attrs:{"v":_vm.$v.content},model:{value:(_vm.content.menus),callback:function ($$v) {_vm.$set(_vm.content, "menus", $$v)},expression:"content.menus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }